import * as account from "./account";
/**
 * @Auther: Qsan
 * @Date：2018年12月12日 00:22
 * @Desc：接口统一导入
 */
import * as common from "./common";
import * as data from "./data";
import * as goods from "./goods";
import * as market from "./market";
import * as member from "./member";
import * as money from "./money";
import * as order from "./order";
import * as setting from "./setting";
import * as store from "./store";
import * as workbench from "./workbench";
import * as employee from "./employee";
import * as brand from "./brand";
import * as paperless from "./paperless";

const API = {
  common: { ...common },
  account: { ...account },
  data: { ...data },
  market: { ...market },
  member: { ...member },
  money: { ...money },
  order: { ...order },
  setting: { ...setting },
  goods: { ...goods },
  store: { ...store },
  workbench: { ...workbench },
  employee: { ...employee },
  brand: { ...brand },
  paperless: { ...paperless },
};

const install = function(Vue, opts = {}) {
  Vue.prototype.API = API;
};

export default {
  ...API,
  install,
};



// WEBPACK FOOTER //
// ./src/api/index.js